import React, {useContext, useEffect} from 'react';
import { UserRegistrationContext } from "./ShareStates";
import SerialNumberForm from "./SerialNumberForm";
import ZipForm from "./ZipForm";
import RegionForm from "./RegionForm";
import AccountForm from "./AccountForm";
import RegistrationCompleteForm from "./RegistrationCompleteForm";
import { returnCommonVariables } from "../../../commonVariables";

const UserRegisterLandingPage = () => {
    const {displayForm, updateDisplayForm} = useContext(UserRegistrationContext);

    useEffect(() => {
        if (displayForm === "") {
            updateDisplayForm("serialNumberForm")
        }
    }, [displayForm, updateDisplayForm]);


    const redirectToLogin = (event) => {
        // console.log(event.target.id);
        event.preventDefault();
        if (event.target.id === "login") {
            return window.location = returnCommonVariables()["loginURL"]
        }
    }

    let loadContent = null;
    if (displayForm === "serialNumberForm") {
        loadContent = <SerialNumberForm />
    }
    if (displayForm === "zipForm") {
        loadContent = <ZipForm />
    }
    if (displayForm === "accountForm") {
        loadContent = <AccountForm />
    }
    if (displayForm === "regionForm") {
        loadContent = <RegionForm />
    }
    if (displayForm === "registrationCompletedForm") {
        return (
            <div>
                <React.Fragment>
                    <RegistrationCompleteForm />
                </React.Fragment>
            </div>
        )
    }
    return (
        <div>
            <React.Fragment>
                <form name={"stepform"} className={"step"}>
                    {loadContent}
                </form>
                <div>
                    <p style={{paddingTop: "15px"}}>
                        Already have an account? <a id={"login"} href={"/"} style={{cursor: "pointer"}} onClick={redirectToLogin}> Log in here.</a>
                    </p>
                </div>
            </React.Fragment>
        </div>
    )
}

export default UserRegisterLandingPage;
